// src/components/common/popup.js
// =============================================================
// Sistem POPUP GLOBAL (gaya SweetAlert): popup tengah + tombol OK,
// dan dialog konfirmasi Ya/Tidak. Bisa dipanggil dari mana saja
// (komponen maupun non-komponen) tanpa perlu useContext.
//
// Pemakaian:
//   import { popup } from "<path>/components/common/popup";
//   popup.success("Data berhasil disimpan");
//   popup.error("Gagal menyimpan data");
//   const ok = await popup.confirm("Yakin ingin menghapus data ini?");
//   if (!ok) return;
//
// Host-nya (PopupHost) cukup dipasang SEKALI di App.js.
// =============================================================

let listeners = new Set();
let current = null; // request popup yang sedang tampil, atau null
const queue = []; // antrean bila ada popup menyusul saat satu sedang tampil
let seq = 0;

const emit = () => listeners.forEach((l) => l());

const push = (req) => {
  if (current) {
    queue.push(req);
  } else {
    current = req;
    emit();
  }
};

// Deteksi ikon otomatis dari isi pesan (untuk popup.alert generik).
const detectType = (message) => {
  const m = String(message || "").toLowerCase();
  if (/(berhasil|sukses|tersimpan|disimpan|selesai|ditambah|diperbarui|diupdate|dihapus|dikembalikan)/.test(m))
    return "success";
  if (/(gagal|error|salah|invalid|wajib|tidak dapat|tidak bisa|tidak ditemukan|kesalahan)/.test(m))
    return "error";
  return "info";
};

export const popupStore = {
  subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  getCurrent() {
    return current;
  },
  // Dipanggil host saat user menekan tombol. value: true/false (untuk confirm).
  resolve(value) {
    const req = current;
    current = queue.shift() || null;
    emit();
    if (req && typeof req.resolve === "function") req.resolve(value);
  },
};

export const popup = {
  // Popup informasi dengan tombol OK. Mengembalikan Promise yang resolve
  // saat ditutup (jarang perlu di-await).
  alert(message, opts = {}) {
    return new Promise((resolve) => {
      push({
        id: ++seq,
        mode: "alert",
        type: opts.type || detectType(message),
        title: opts.title || null,
        message,
        confirmText: opts.confirmText || "OK",
        resolve,
      });
    });
  },
  success(message, opts = {}) {
    return this.alert(message, { ...opts, type: "success" });
  },
  error(message, opts = {}) {
    return this.alert(message, { ...opts, type: "error" });
  },
  info(message, opts = {}) {
    return this.alert(message, { ...opts, type: "info" });
  },
  // Dialog konfirmasi. Mengembalikan Promise<boolean>: true bila user
  // menekan tombol konfirmasi (Ya), false bila Batal / tutup.
  confirm(message, opts = {}) {
    return new Promise((resolve) => {
      push({
        id: ++seq,
        mode: "confirm",
        type: opts.type || "warning",
        title: opts.title || "Konfirmasi",
        message,
        confirmText: opts.confirmText || "Ya",
        cancelText: opts.cancelText || "Batal",
        resolve,
      });
    });
  },
};

export default popup;
